import React, { useEffect } from 'react';
import './DetailsExamens.scss';
import { LiferayProps } from '../..';
import ButtonFormMf from '../../commons/Button/ButtonFormMf';
import { useFormContext } from "../context/FormContext";

interface DetailsExamens{
    codeCups: number,
    laboratoryCode: number,
    testName: string,
    abbreviation: string,
    synonym: string,
    referred:string,
    pbs: string,
    processingReferralSite: string,
    sampleType: string,
    sampleConditions: string,
    sampleVolume: string,
    stability: string,
    technique: string,
    referenceValues: string,
    patientConditions: string,
    clinicalInformationPatient: string,
    additionalClinicalInformationFormat: string,
    consentFormat: string,
    downloadFormatHere: string,
    clinicalUtility: string,
    processingDays: string,
    resultDeliveryTime: string,
    specialConsiderations: string,
    complementaryTests: string,
    titles: string,
    celPhone: string,
    email: string
}

interface TitleCustomize {
    hideField: boolean;
    text: string;
    value: string;
}

const Details: React.FC<LiferayProps> = ({properties}) => {

    const { stateCompany, dataTitles } = useFormContext();

    const cardData = sessionStorage.getItem('cardData');
    const card = cardData ? JSON.parse(cardData) : null;
    const variable = card.downloadFormatHere;
  
  const root = document.documentElement
  const customAlign = properties.alignTextDetails !== null ? properties.alignTextDetails : "left";
  const customTextTransform = properties.textTransform  !== null ? properties.textTransform : 'none';

  root.style.setProperty('--align-text', customAlign) 
  root.style.setProperty('--text-transform', customTextTransform)  

    return (
        <>                
        <div className="mf-k-details-container container" >
            <section className="mf-k-details-container__details">
                <div className="mf-k-details-container__content">
                <h2 className="mf-k-details-container__title">{card?.testName}</h2>
                <div className="mf-k-details-container__item" 
                style={{ display: dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_CODIGO_CUPS')?.hideField ? 'none' : 'block' }}>
                    <h3 className="mf-k-details-container__item--title">{dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_CODIGO_CUPS')?.text}</h3>
                    <p className="mf-k-details-container__item--content">{card?.codeCups}</p>
                    
                </div>
                <div className="mf-k-details-container__item" 
                style={
                    {display: dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_CODIGO_LABORATORIO')?.hideField ? 'none' : 'block'}}>
                    <h3 className="mf-k-details-container__item--title">{dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_CODIGO_LABORATORIO')?.text}</h3>
                    <p className="mf-k-details-container__item--content">{card?.laboratoryCode}</p>
                </div>
                <div className="mf-k-details-container__item" 
                style={{display: dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_REMITIDA')?.hideField ? 'none' : 'block'}}
                >
                    <h3 className="mf-k-details-container__item--title">{dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_REMITIDA')?.text}</h3>
                    <p className="mf-k-details-container__item--content">
                        {card?.referred }
                        </p>
                </div>
                <div className="mf-k-details-container__item"
                style={{display: dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_PBS')?.hideField || stateCompany ? 'none' : 'block'}}
                >
                    <h3 className="mf-k-details-container__item--title">{dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_PBS')?.text}</h3>
                    <p className="mf-k-details-container__item--content">
                        {card?.pbs }
                        </p>
                </div>
                <div className="mf-k-details-container__item"
                style={{display: dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_TIPO_MUESTRA')?.hideField ? 'none' : 'block'}}
                >
                    <h3 className="mf-k-details-container__item--title">{dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_TIPO_MUESTRA')?.text}</h3>
                    <p className="mf-k-details-container__item--content">{card?.sampleType }</p>
                </div>
                <div className="mf-k-details-container__item"
                style={{display: dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_SINONIMO')?.hideField}}
                >
                    <h3 className="mf-k-details-container__item--title">{dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_SINONIMO')?.text}</h3>
                    <p className="mf-k-details-container__item--content">
                        {card?.synonym}
                        </p>
                </div>
                <div className="mf-k-details-container__item"
                style={{display: dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_ABREVIATURA')?.hideField || stateCompany ? 'none' : 'block'}}
                >
                    <h3 className="mf-k-details-container__item--title">{dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_ABREVIATURA')?.text}</h3>
                    <p className="mf-k-details-container__item--content">
                        {card?.abbreviation}
                    </p>
                </div>
                <div className="mf-k-details-container__item"
                style={{display: dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_CONDICIONES_MUESTRA')?.hideField || stateCompany ? 'none' : 'block'}}
                >
                    <h3 className="mf-k-details-container__item--title">{dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_CONDICIONES_MUESTRA')?.text}</h3>
                    <p className="mf-k-details-container__item--content">
                        {card?.sampleConditions }
                    </p>
                </div>
                <div className="mf-k-details-container__item"
                style={{display: dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_VOLUMEN_MUESTRA')?.hideField || stateCompany ? 'none' : 'block'}}
                >
                    <h3 className="mf-k-details-container__item--title">{dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_VOLUMEN_MUESTRA')?.text}</h3>
                    <p className="mf-k-details-container__item--content">
                        {card?.sampleVolume }
                    </p>
                </div>
                <div className="mf-k-details-container__item"
                style={{display: dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_CONDICIONES_PACIENTE')?.hideField ? 'none' : 'block'}}
                >
                    <h3 className="mf-k-details-container__item--title">{dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_CONDICIONES_PACIENTE')?.text}</h3>
                    <p className="mf-k-details-container__item--content">
                        {card?.patientConditions}
                    </p>
                </div>
                <div className="mf-k-details-container__item"
                style={{display: dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_INFORMACION_CLINICA_PACIENTE')?.hideField || stateCompany ? 'none' : 'block'}}
                >
                    <h3 className="mf-k-details-container__item--title">{dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_INFORMACION_CLINICA_PACIENTE')?.text}</h3>
                    <p className="mf-k-details-container__item--content">
                        {card?.clinicalInformationPatient}
                        </p>
                </div>
                <div className="mf-k-details-container__item"
                style={{display: dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_ESTABILIDAD')?.hideField || stateCompany ? 'none' : 'block'}}
                >
                    <h3 className="mf-k-details-container__item--title">{dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_ESTABILIDAD')?.text}</h3>
                    <p className="mf-k-details-container__item--content">
                        {card?.stability}
                        </p>
                </div>
                <div className="mf-k-details-container__item"
                style={{display: dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_FORMATO_INFORMACION_CLINICA_ADICIONAL')?.hideField || stateCompany ? 'none' : 'block'}}
                >
                    <h3 className="mf-k-details-container__item--title">{dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_FORMATO_INFORMACION_CLINICA_ADICIONAL')?.text}</h3>
                    <p className="mf-k-details-container__item--content">
                        {card?.additionalClinicalInformationFormat }
                        </p>
                </div>
                <div className="mf-k-details-container__item"
                style={{display: dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_TECNICA')?.hideField || stateCompany ? 'none' : 'block'}}
                >
                    <h3 className="mf-k-details-container__item--title">{dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_TECNICA')?.text}</h3>
                    <p className="mf-k-details-container__item--content">
                        {card?.technique}
                        </p>
                </div>
                <div className="mf-k-details-container__item"
                style={{display: dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_VALORES_REFERENCIA')?.hideField || stateCompany ? 'none' : 'block'}}
                >
                    <h3 className="mf-k-details-container__item--title">{dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_VALORES_REFERENCIA')?.text}</h3>
                    <p className="mf-k-details-container__item--content">
                        {card?.referenceValues}
                        </p>
                </div>
                <div className="mf-k-details-container__item"
                style={{display: dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_UTILIDAD_CLINICA')?.hideField ? 'none' : 'block'}}
                >
                    <h3 className="mf-k-details-container__item--title">{dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_UTILIDAD_CLINICA')?.text}</h3>
                    <p className="mf-k-details-container__item--content">
                        {card?.clinicalUtility}
                        </p>
                </div>
                <div className="mf-k-details-container__item"
                style={{display: dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_DIAS_PROCESAMIENTO')?.hideField ? 'none' : 'block'}}
                >
                    <h3 className="mf-k-details-container__item--title">{dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_DIAS_PROCESAMIENTO')?.text}</h3>
                    <p className="mf-k-details-container__item--content">
                        {card?.processingDays}
                        </p>
                </div>
                <div className="mf-k-details-container__item"
                style={{display: dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_TIEMPO_ENTREGA_RESULTADO')?.hideField ? 'none' : 'block'}}
                >
                    <h3 className="mf-k-details-container__item--title">{dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_TIEMPO_ENTREGA_RESULTADO')?.text}</h3>
                    <p className="mf-k-details-container__item--content">
                        {card?.resultDeliveryTime}
                        </p>
                </div>
                <div className="mf-k-details-container__item"
                style={{display: dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_FORMATO_CONSENTIMIENTO')?.hideField || stateCompany ? 'none' : 'block'}}
                >
                    <h3 className="mf-k-details-container__item--title">{dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_FORMATO_CONSENTIMIENTO')?.text}</h3>
                    <p className="mf-k-details-container__item--content">
                        {card?.consentFormat}
                        </p>
                </div>
                <div style={{display: typeof variable === 'string' && variable.startsWith('/') ? 'block' : 'none'}}>
                    <div className="mf-k-details-container__item"
                    style={{display: dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_DESCARGUE_FORMATO_AQUI')?.hideField || stateCompany ? 'none' : 'block'}}
                    >
                        <h3 className="mf-k-details-container__item--title">{dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_DESCARGUE_FORMATO_AQUI')?.text}</h3>
                        <a href={card?.downloadFormatHere || '#'} aria-label="Descargar">{card?.titles}</a>
                    </div>
                </div>
                <div className="mf-k-details-container__item"
                style={{display: dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_SITIO_REMISION_PROCESAMIENTO')?.hideField ? 'none' : 'block'}}
                >
                    <h3 className="mf-k-details-container__item--title">{dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_SITIO_REMISION_PROCESAMIENTO')?.text}</h3>
                    <p className="mf-k-details-container__item--content">
                        {card?.processingReferralSite}
                        </p>
                </div>
                <div className="mf-k-details-container__item"
                style={{display: dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_CONSIDERACIONES_ESPECIALES')?.hideField || stateCompany ? 'none' : 'block'}}
                >
                    <h3 className="mf-k-details-container__item--title">{dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_CONSIDERACIONES_ESPECIALES')?.text}</h3>
                    <p className="mf-k-details-container__item--content">
                        {card?.specialConsiderations}
                        </p>
                </div>
                <div className="mf-k-details-container__item"
                style={{display: dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_PRUEBAS_COMPLEMENTARIAS')?.hideField ||  stateCompany ? 'none' : 'block'}}
                >
                    <h3 className="mf-k-details-container__item--title">{dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_PRUEBAS_COMPLEMENTARIAS')?.text}</h3>
                    <p className="mf-k-details-container__item--content">
                        {card?.complementaryTests}
                        </p>
                </div>
                </div>
            
        </section>
        
        <div className='mf-k-details-container__buttons'
                style={{display: stateCompany ? 'flex' : 'none'}}
        >
            <ButtonFormMf         
                txtButton={"Directorio de sedes"}
                styleCustomize="k-button-form-details"
                disabledButton={false}
                iconCustomize={"headquarters"}
                backgroundCustomize=""
                onClick={() =>{
                    window.location.href = ('/web/empresas/directorio-de-sedes');
                }}
            />
            <ButtonFormMf
                txtButton={"Agenda tu cita"}
                styleCustomize={"k-button-form-details second-button"}
                iconCustomize={"iconCalendar"}
                disabledButton={false}
                backgroundCustomize=""
                onClick={() =>{
                    window.location.href = ('https://oficinavirtual.clinicacolsanitas.com/iniciar-sesion');
                }}
            />
        </div>
        </div>
        <div className='mf-k-details-container__separator' style={{display: stateCompany ? 'none' : 'block'}}>
            <section className="l-c-bg-title" style={{position: 'relative', top: '5px'}}>
                    <div className="l-c-bg-title__triangle--gray"
                        style={{borderTopColor: 'gray', backgroundColor: '#D9D9D9'}}></div>
                    <div className="l-c-bg-title__triangle-inside--gray" style={{backgroundColor: 'gray'}}>
                    </div>
            </section>
        </div>
        <section className='mf-k-moreinfo container' style={{display: stateCompany ? 'none' : 'block'}}>
            <h3 className='mf-k-moreinfo__title'>Para más información comuniquese</h3>
            <h3 className='mf-k-moreinfo__title'>con nuestro servicio al cliente</h3>
            <br />
            <p className='mf-k-moreinfo__item'><strong>Celular: </strong>315 335 4485</p>
            <p className='mf-k-moreinfo__item'><strong>Email: </strong>labreferenciaserviciocliente@colsanitas.com</p>
        </section>        
      
    </>
    );
  };

export default Details;